export enum OriginEventType {
  MOUSE_DOWN = 'mousedown',
  MOUSE_MOVE = 'mousemove',
  MOUSE_OUT = 'mouseout',
  MOUSE_LEAVE = 'mouseleave',
  MOUSE_UP = 'mouseup',
  KEY_DOWN = 'keydown',
  KEY_UP = 'keyup',
  CLICK = 'click',
  HOVER = 'hover',
  DOUBLE_CLICK = 'dblclick',
  CONTEXT_MENU = 'contextmenu',
}
